import { Box, CircularProgress, Container, Stack } from '@mui/material';
import axios from 'axios';
import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EmployeeBasicInfo from '../components/EmployeeBasicInfo';
import Page from '../components/Page';

import PageHeader from '../components/smallComponents/PageHeader';
import WorkerDetailPageTabs from '../components/cardTabs/WorkerDetailPageTabs';
import SingleWorkerAnalytics from '../components/SingleWorkerAnalytics';

export default function ViewWorker() {
  const { accType } = useSelector((state) => state.user.userInfo);
  const admin = accType === 'SUPER_ADMIN' || accType === 'SUB_ADMIN';

  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [employee, setEmployee] = useState({});

  const getEmployee = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/member/worker`, {
        params: {
          id,
        },
      });
      console.log('employee', res);
      setEmployee(res.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmployee();
  }, [id]);

  return (
    <Page title="Worker">
      {isLoading ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItem: 'center',
            height: '50vh',
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <Container maxWidth="xl">
          <PageHeader title="Worker" />
          <Stack sx={{ width: '100%' }} spacing={2}>
            <Box id="basic-info" marginBottom={1}>
              <EmployeeBasicInfo getEmployee={getEmployee} employee={employee} />
            </Box>
            <Box id="basic-info" marginBottom={1}>
              <WorkerDetailPageTabs worker={employee} />
            </Box>
            <Box id="basic-info" marginBottom={1}>
              <SingleWorkerAnalytics />
            </Box>
          </Stack>
        </Container>
      )}
    </Page>
  );
}
